import { DesignData } from 'editor/src/store/design/types';

/**
 * IDML imports arrive from the backend with every layer added to the spread's
 * conditionGroup and `personalizationLocked` unset — i.e. personalization is ON
 * for all imported layers. Product owners want the opposite: import everything
 * with personalization OFF so the user explicitly switches on only the layers
 * they need.
 *
 * This locks personalization on every imported media element and removes the
 * auto-built conditionGroup, so all layers render under "Other layers" with the
 * toggle off. Turning a layer on later re-creates the conditionGroup via
 * addElementToConditionGroupOperation.
 */
function disablePersonalizationForImport(designData: DesignData): DesignData {
  return {
    ...designData,
    spreads: designData.spreads.map((spread) => ({
      ...spread,
      conditionGroup: undefined,
      pages: spread.pages.map((page) => ({
        ...page,
        groups: {
          ...page.groups,
          media: page.groups.media?.map((element) => ({
            ...element,
            personalizationLocked: true as const,
          })),
        },
      })),
    })),
  };
}

export default disablePersonalizationForImport;
